<section class="">
  <!-- Form -->
  <form [formGroup]="formData" class="space-y-5">
    <!-- Name & Alias -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <app-custom-input [label]="'Name of Product'" [showAsteric]="true" [showLabel]="true"
          [placeholder]="'--type product name here--'" formControlName="name"></app-custom-input>
        @if (formData.get('name')?.invalid && (formData.get('name')?.touched || formData.get('name')?.dirty)) {
        <div class="text-error text-xs mt-2">Name is required.</div>
        }
      </div>
      <div>
        <app-custom-input [label]="'Alias'" [showAsteric]="true" [showLabel]="true"
          [placeholder]="'--type product alias here--'" formControlName="code"></app-custom-input>
        @if (formData.get('code')?.invalid && (formData.get('code')?.touched || formData.get('code')?.dirty)) {
        <div class="text-error text-xs mt-2">Alias is required.</div>
        }
      </div>
    </div>

    <!-- Category & Disbursement Type -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <app-select-option [options]="categories" [label]="'Category'" [showAsteric]="true"
          formControlName="categoryId"></app-select-option>
        @if (formData.get('categoryId')?.invalid && (formData.get('categoryId')?.touched ||
        formData.get('categoryId')?.dirty)) {
        <div class="text-error text-xs mt-2">Category is required.</div>
        }
      </div>
      <div>
        <app-select-option [options]="disbursementTypes" [label]="'Disbursement Type'"
          formControlName="disbursementType"></app-select-option>
      </div>
    </div>

    <!-- Tenure Type & Maximum Tenure -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <app-select-option [options]="tenureTypes" [label]="'Tenure Type'" [showAsteric]="true"
          formControlName="tenureType"></app-select-option>
        @if (formData.get('tenureType')?.invalid && (formData.get('tenureType')?.touched ||
        formData.get('tenureType')?.dirty)) {
        <div class="text-error text-xs mt-2">Tenure type is required.</div>
        }
      </div>
      <div class="relative">
        <app-select-option [options]="maxTenureOptions()" [label]="maxTenureLabel()" [showAsteric]="true"
          formControlName="maxTenure"></app-select-option>
        @if (maxTenureDisabled()) {
        <div class="absolute top-0 right-0 group">
          <svg class="w-3.5 h-3.5 text-slate-400 cursor-help" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div
            class="hidden group-hover:block absolute right-0 bottom-full mb-2 w-56 p-2 rounded-lg bg-slate-900 dark:bg-slate-700 text-white text-[11px] leading-snug shadow-lg z-10">
            Only applicable when Tenure Type is Monthly or Weekly. Daily products don't need a maximum tenure.
          </div>
        </div>
        }
        @if (formData.get('maxTenure')?.invalid && (formData.get('maxTenure')?.touched ||
        formData.get('maxTenure')?.dirty)) {
        <div class="text-error text-xs mt-2">Maximum tenure is required.</div>
        }
      </div>
    </div>

    <!-- Repayment Mode & Minimum Amount -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <app-select-option [options]="repaymentModes" [label]="'Repayment Mode'"
          formControlName="repaymentMode"></app-select-option>
      </div>
      <div>
        <app-custom-input [label]="'Minimum Amount'" [showAsteric]="true" [showLabel]="true"
          [placeholder]="'--set minimum amount--'" formControlName="minAmount"></app-custom-input>
        @if (formData.get('minAmount')?.invalid && (formData.get('minAmount')?.touched ||
        formData.get('minAmount')?.dirty)) {
        <div class="text-error text-xs mt-2">Minimum amount is required.</div>
        }
      </div>
    </div>

    <!-- Minimum Age & Maximum Age -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <app-custom-input [label]="'Minimum Age'" [showAsteric]="true" [showLabel]="true"
          [placeholder]="'--set minimum age--'" formControlName="minAgeLimit"></app-custom-input>
        @if (formData.get('minAgeLimit')?.invalid && (formData.get('minAgeLimit')?.touched ||
        formData.get('minAgeLimit')?.dirty)) {
        <div class="text-error text-xs mt-2">Minimum age is required.</div>
        }
      </div>
      <div>
        <app-custom-input [label]="'Maximum Age'" [showAsteric]="true" [showLabel]="true"
          [placeholder]="'--set maximum age--'" formControlName="maxAgeLimit"></app-custom-input>
        @if (formData.get('maxAgeLimit')?.invalid && (formData.get('maxAgeLimit')?.touched ||
        formData.get('maxAgeLimit')?.dirty)) {
        <div class="text-error text-xs mt-2">Maximum age is required.</div>
        }
      </div>
    </div>

    <!-- Auto Repayment Toggle -->
    <div class="bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 rounded-lg p-4">
      <div class="flex items-center justify-between">
        <div>
          <label class="text-xs font-medium text-slate-900 dark:text-white block mb-1">Auto Repayment <span
              class="text-error">*</span></label>
          <p class="text-xs text-slate-500 dark:text-slate-400">Enable automatic repayment for this product</p>
        </div>
        <button type="button" (click)="toggleAutoRepayment()"
          [style.background-color]="autoRepaymentValue ? '#0D76BA' : '#CBD5E1'"
          class="relative inline-flex h-7 w-14 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none">
          <span [class]="autoRepaymentValue ? 'translate-x-7' : 'translate-x-0'"
            class="pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white dark:bg-slate-800 shadow ring-0 transition duration-200 ease-in-out"></span>
        </button>
      </div>
      <div class="mt-3 flex items-center gap-2 text-sm">
        <span [class]="!autoRepaymentValue ? 'text-slate-900 dark:text-white font-medium' : 'text-slate-500 dark:text-slate-400'">No</span>
        <span [class]="autoRepaymentValue ? 'text-primary-800 dark:text-primary-400 font-medium' : 'text-slate-500 dark:text-slate-400'">Yes</span>
      </div>
    </div>

    <!-- Interest Rate & Processing Fee Rate -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label class="block text-xs font-normal text-gray-600 dark:text-slate-400 mb-1.5">Interest Rate</label>
        <div class="relative">
          <app-custom-input [showLabel]="false" [type]="'number'" [placeholder]="'0.00'"
            formControlName="interestRate"></app-custom-input>
          <span class="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-semibold text-slate-400 pointer-events-none select-none">%</span>
        </div>
      </div>
      <div>
        <label class="block text-xs font-normal text-gray-600 dark:text-slate-400 mb-1.5">Processing Fee Rate</label>
        <div class="relative">
          <app-custom-input [showLabel]="false" [type]="'number'" [placeholder]="'0.00'"
            formControlName="processingFeeRate"></app-custom-input>
          <span class="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-semibold text-slate-400 pointer-events-none select-none">%</span>
        </div>
      </div>
    </div>

    <!-- Select Institutions -->
    <div class="bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 rounded-lg p-4">
      <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-3 block">Assign Institutions</label>

      <!-- Selected Institutions -->
      <div class="mb-3">
        <div
          class="flex items-center justify-between p-3 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg cursor-pointer hover:border-primary-800 transition-colors">
          <div class="flex flex-wrap gap-2">
            @for (selectedInstitution of selectedInstitutions; track $index) {
            <div class="flex items-center gap-1.5 px-2.5 py-1 rounded text-[11px] font-semibold text-white bg-primary-800">
              <span>{{ selectedInstitution.name }}</span>
              <button type="button" (click)="onRemoveFromList(selectedInstitution); $event.stopPropagation()"
                class="hover:bg-white dark:bg-slate-800/20 rounded-full p-0.5 transition-colors leading-none">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
              </button>
            </div>
            }
            @if (selectedInstitutions.length === 0) {
            <span class="text-slate-400 text-xs">Select institutions...</span>
            }
          </div>
          <img [src]="_images.arrowDwon" alt="dropdown" class="w-4 h-4 opacity-40" />
        </div>
      </div>

      <!-- Available Institutions -->
      <div class="max-h-48 overflow-y-auto bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg">
        @if (allInstitutions.length > 0) {
        @for (institution of allInstitutions; track $index) {
        <div (click)="onAddToSelectedInstitutions(institution)"
          class="flex items-center justify-between px-3 py-2.5 hover:bg-blue-50/60 cursor-pointer transition-colors border-b border-slate-50 last:border-b-0">
          <p class="text-xs font-medium text-slate-700 dark:text-slate-300">{{ institution.name }}</p>
          @if (isInstitutionSelected(institution)) {
          <img [src]="_images.checkIcon" alt="selected" class="w-4 h-4" style="filter: brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(1352%) hue-rotate(88deg) brightness(118%) contrast(119%);" />
          }
        </div>
        }
        } @else {
        <p class="p-4 text-center text-slate-400 text-xs">No Institution Found</p>
        }
      </div>
    </div>

    <!-- Submit Button -->
    <div class="pt-4">
      <app-custom-button [text]="product() ? 'Update' : 'Confirm'" [isLoading]="isLoading"
        (onClick)="createNewProduct()"></app-custom-button>
    </div>
  </form>
</section>
